import displayNames from './kashew_velou_attributeValues_display_names';
import displayNames2 from './kashew_velou_attributeNames_display_names';

const getVelouDisplayName = (item) => {
	if (typeof item !== 'string') {
		return '';
	}
	if (displayNames[item?.toLowerCase()]) {
		return displayNames[item?.toLowerCase()];
	} else if (displayNames2[item?.toLowerCase()]) {
		return displayNames2[item?.toLowerCase()];
	} else {
		return item
			?.replace(/_/g, ' ')
			?.split(' ')
			?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			?.join(' ');
	}
};

export default getVelouDisplayName;
